var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-container"},[_c('div',{staticClass:"slider"},[_c('h1',[_vm._v("PLU")]),_vm._v(" "),_c('h1',[_vm._v("PLUi")]),_vm._v(" "),_c('h1',[_vm._v("SCoT")]),_vm._v(" "),_c('h1',[_vm._v("PLU")])])])
}]

export { render, staticRenderFns }